/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SpoMainPageComponent} from './spo-main-page/spo-main-page.component';
import {SpoCreateNewComponent} from './spo-create-new/spo-create-new.component';
import {SpoDetailPageComponent} from './spo-detail-page/spo-detail-page.component';
import {SpoDetailResolver} from './services/spo-detail/spo-detail.resolver.service';
import {SpoEditPageComponent} from './spo-edit-page/spo-edit-page.component';
import {RoutingMenuItemModel} from '../shared/utils/routing-menu-item.model';
import {Permission} from '../shared/utils/permission.enum';
import {PermissionsGuard} from '../permissions.guard';
import {UnsavedChangesGuard} from '../shared/guards/unsaved-work/unsaved-changes.guard';
import {SpoEditGuardResolverService} from './spo-edit-page/guard/spo-edit-guard.resolver.service';

export const routes: Routes = [
    {
        path: 'spo',
        canActivate: [PermissionsGuard],
        canActivateChild: [PermissionsGuard],
        data: {
            hasSideBarMenu: true,
            breadcrumb: 'SPO',
            permissions: [Permission.PARTNER_SPO_VIEW, Permission.ADMIN_SPO_VIEW],
            menuItem: {
                label: 'SPO',
                icon: 'iwp-icon-gen_special_orders',
                index: 1
            } as RoutingMenuItemModel
        },
        children: [
            {
                path: '',
                component: SpoMainPageComponent,
                data: {
                    hasSideBarMenu: true,
                    hasStickyHeader: true,
                    permissions: [Permission.PARTNER_SPO_VIEW, Permission.ADMIN_SPO_VIEW],
                    menuItem: {
                        label: 'View list'
                    } as RoutingMenuItemModel
                }
            },
            {
                path: 'new',
                component: SpoCreateNewComponent,
                canDeactivate: [UnsavedChangesGuard],
                data: {
                    hasSideBarMenu: true,
                    breadcrumb: 'Create new SPO',
                    permissions: [Permission.PARTNER_SPO_CREATE],
                    menuItem: {
                        label: 'New',
                        index: 1
                    } as RoutingMenuItemModel
                }
            },
            {
                path: ':sponumber',
                data: {
                    hasSideBarMenu: true,
                    breadcrumb: 'SPO :sponumber'
                },
                children: [
                    {
                        path: '',
                        component: SpoDetailPageComponent,
                        resolve: {spoDetail: SpoDetailResolver},
                        data: {
                            hasSideBarMenu: true,
                            hasStickyHeader: true,
                            permissions: [Permission.PARTNER_SPO_VIEW, Permission.ADMIN_SPO_VIEW]
                        }
                    },
                    {
                        path: 'edit',
                        component: SpoEditPageComponent,
                        canDeactivate: [UnsavedChangesGuard],
                        resolve: {spoDetail: SpoEditGuardResolverService},
                        data: {
                            breadcrumb: 'Edit',
                            permissions: [Permission.PARTNER_SPO_EDIT]
                        }
                    }
                ]
            }]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SpoRoutingModule {
}
